import { twMerge } from 'src/utils/tw-merge.util'
import { useTranslation } from 'react-i18next'
import List, { ListItem } from '../list/list.component'
import { CurecallBadge, ECurecallBadgeColor } from '@honestica/curecall-ui'
import Card from 'src/components/card/card.component'
import { TPatientVariable } from 'src/types/variable'
import { TPatientForm } from 'src/types/form'

interface Morisky8CardProps {
  form: TPatientForm
}

const Morisky8Card = ({ form }: Morisky8CardProps) => {
  const { t } = useTranslation()
  const patientVariables = form?.PatientVariables
  const score = patientVariables?.find((variable) => variable.Variable.settings?.isScoringVariable)
    ?.value as string
  const morisky8Variables = patientVariables?.filter(
    (variable) => !variable.Variable.settings?.isScoringVariable,
  )

  const getMorisky8Value = (patientVariable: TPatientVariable) => {
    if (patientVariable.Variable.name === 'difficultyRememberingToTakeMedication') {
      return Number(patientVariable.value) * 4
    }
    return patientVariable.value ? t('common.yes') : t('common.no')
  }

  const listItems: ListItem[] =
    morisky8Variables?.map((patientVariable) => ({
      label: patientVariable.Variable.label,
      value: (
        <CurecallBadge
          color={ECurecallBadgeColor.SMOOTH_PRIMARY}
          className="tw-text-sm tw-px-2 tw-w-14 tw-text-center"
        >
          {getMorisky8Value(patientVariable)}
        </CurecallBadge>
      ),
    })) || []

  return (
    <Card
      title={t('components.patient.patient-file.body.followup-details.morisky-score-title')}
      className="c-relative"
    >
      <div
        className={twMerge(
          'c-absolute c-right-0 c-top-0 c-rounded-bl-[0.75rem] c-p-4 c-bg-[#F5F5F5] c-text-[#D7D7D7] c-font-bold',
          score && 'c-bg-[#D9E2FF]',
        )}
      >
        <span className="c-text-4xl c-text-primary-600">{score} </span>
        <span className={twMerge('c-text-2xl c-text-[#798DF1]')}>/ 8</span>
      </div>

      <div className="c-mt-10">
        {listItems?.length ? (
          <List list={listItems} ordered />
        ) : (
          <div className="text-muted c-text-base">
            {t('components.patient.patient-file.body.followup-details.no-information-available')}
          </div>
        )}
      </div>
    </Card>
  )
}

export default Morisky8Card
